import { Provider } from '@navikt/ds-react/Provider';
import { nb } from '@navikt/ds-react/locales';
import { Checkbox } from '@navikt/ds-react/Checkbox';
import { Chips } from '@navikt/ds-react/Chips';
import { UNSAFE_Combobox as Combobox } from '@navikt/ds-react/Combobox';
import {
	DatePicker,
	useDatepicker,
	useRangeDatepicker,
} from '@navikt/ds-react/DatePicker';
import { Fieldset } from '@navikt/ds-react/Fieldset';
import { Loader } from '@navikt/ds-react/Loader';
import { MonthPicker } from '@navikt/ds-react/MonthPicker';
// Exported so fields that Aksel does not cover (the markdown editor) can use
// the same label and error line.
import { ErrorMessage, Label } from '@navikt/ds-react/Typography';
import { Radio, RadioGroup } from '@navikt/ds-react/Radio';
import { Search } from '@navikt/ds-react/Search';
import { Select } from '@navikt/ds-react/Select';
import { Switch } from '@navikt/ds-react/Switch';
import { Textarea } from '@navikt/ds-react/Textarea';
import { TextField } from '@navikt/ds-react/TextField';
import { ToggleGroup } from '@navikt/ds-react/ToggleGroup';
import { Tooltip } from '@navikt/ds-react/Tooltip';
// Only the component sheets these controls need. ⛔ Do not import the global
// sheets: `reset.css` and `baseline.css` restyle `html` and `body` on all
// legacy screens.
import '@navikt/ds-css/dist/global/tokens.css';
import '@navikt/ds-css/dist/component/typography.css';
import '@navikt/ds-css/dist/component/form.css';
// The combobox hangs its list in a portal and its chips are their own component.
import '@navikt/ds-css/dist/component/chips.css';
// The date calendar opens in an `aksel-popover`. Without the popover sheet it
// is invisible.
import '@navikt/ds-css/dist/component/date.css';
import '@navikt/ds-css/dist/component/popover.css';
import '@navikt/ds-css/dist/component/loader.css';
// The sheets match only `.aksel-*`, so they do not reach the legacy screens.
import '@navikt/ds-css/dist/component/togglegroup.css';
import '@navikt/ds-css/dist/component/tooltip.css';

/**
 * The one place outside `src/flyt` that imports Aksel. ⚠️ Not
 * `flyt/ui/AkselForm`: that file is a copy of the portal's, with a hidden
 * label, no textarea, no switch and its own `value`/`onChange` shapes. The
 * legacy forms need the opposite, and a copy must not be forked. The
 * stylesheets are also imported in `flyt/ui/AkselForm`; webpack keeps one copy.
 * The locale is always `nb`: this app is Norwegian only.
 */
export function AkselLocale({ children }) {
	return <Provider locale={nb}>{children}</Provider>;
}

export {
	Checkbox,
	Chips,
	Combobox,
	DatePicker,
	ErrorMessage,
	Fieldset,
	Label,
	Loader,
	MonthPicker,
	Radio,
	RadioGroup,
	Search,
	Select,
	Switch,
	Textarea,
	TextField,
	ToggleGroup,
	Tooltip,
	useDatepicker,
	useRangeDatepicker,
};
